import { GlBadge } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import MultipleChoiceSelector from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/multiple_choice_selector.vue?vue3';
import MultipleChoiceSelectorItem from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/multiple_choice_selector_item.vue?vue3';
export default {
    name: 'DuoMultiSelectOptions',
    components: {
        GlBadge,
        MultipleChoiceSelector,
        MultipleChoiceSelectorItem
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        checkedIds: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'input'
    ],
    computed: {
        optionRows () {
            const checked = new Set(this.checkedIds);
            return this.options.map((option)=>({
                    ...option,
                    isChecked: checked.has(option.id)
                }));
        }
    }
};
